import { render, staticRenderFns } from "./JobSeeker.vue?vue&type=template&id=78c88973&scoped=true&"
import script from "./JobSeeker.vue?vue&type=script&lang=js&"
export * from "./JobSeeker.vue?vue&type=script&lang=js&"
import style0 from "./JobSeeker.vue?vue&type=style&index=0&id=78c88973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c88973",
  null
  
)

export default component.exports